export default __webpack_public_path__ + "static/media/goshen28.0262ffe2.jpg";